/**
 * 日期格式化函数，将日期对象格式化为 MM/DD 格式
 * @param {Date} date - 日期对象
 * @returns {string} 格式化后的日期字符串
 */
export const formatDate = (date) => {
  return `${date.getMonth() + 1}/${date.getDate()}`
}
export const formatDateItem = (date) => {
  return `${date.getMonth() + 1}/${date.getDate()}`
}

/**
 * 日期格式化函数，将日期对象格式化为 YYYY-MM-DD 格式
 * @param {Date} date - 日期对象
 * @returns {string} 格式化后的日期字符串
 */
export const formatDateForApi = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * 日期格式化函数，将日期对象格式化为指定格式
 * @param {Date} date - 日期对象
 * @param {string} [format='YYYY-MM-DD'] - 格式模板，支持 YYYY/YY/MM/DD
 * @returns {string} 格式化后的日期字符串
 */
export const formatDateTime = (date, format = 'YYYY-MM-DD') => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const shortYear = String(year).slice(2)
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  const milliseconds = String(date.getMilliseconds()).padStart(3, '0')

  const formatMap = {
    YYYY: year,
    YY: shortYear,
    MM: month,
    DD: day,
    HH: hours,
    hh: hours > 12 ? String(hours - 12).padStart(2, '0') : hours, // 12小时制
    mm: minutes,
    ss: seconds,
    SSS: milliseconds,
    A: hours < 12 ? 'AM' : 'PM',
    a: hours < 12 ? 'am' : 'pm',
  }

  return format.replace(/YYYY|YY|MM|DD|HH|hh|mm|ss|SSS|A|a/g, (match) => formatMap[match] || match)
}

/**
 * 开始时间格式化函数，将日期对象格式化为 YYYY-MM-DD-00-00-00 格式
 * @param {Date} date - 日期对象
 * @returns {string} 格式化后的开始时间字符串
 */
export const formatStartTimeForApi = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day} 00:00:00`
}

/**
 * 结束时间格式化函数，将日期对象格式化为 YYYY-MM-DD-23-59-59 格式
 * @param {Date} date - 日期对象
 * @returns {string} 格式化后的结束时间字符串
 */
export const formatEndTimeForApi = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day} 23:59:59`
}

export function formatDateStr(dateStr) {
  // 如果输入为空，返回空字符串或根据需求处理
  if (!dateStr) return ''

  // 分割日期和时间部分，取日期部分
  const datePart = dateStr.split(' ')[0]
  // 按 '-' 分割年、月、日
  const [year, month, day] = datePart.split('-')

  // 确保分割后得到三部分，否则返回原字符串或处理错误
  if (year && month && day) {
    // 格式为 DD/MM/YYYY
    return `${day}/${month}/${year}`
  } else {
    // 如果格式不符合预期，返回原字符串或抛出错误，这里返回原字符串
    return dateStr
  }
}

export const formatDateFmt = (date, fmt) => {
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds(),
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}
